module.exports = __webpack_public_path__ + "static/media/bacon-egger-desktop-250_en.184c2501.jpg";